import WithSteps from '@/apps/office/containers/table/shared/dialogs/with-steps';
import Confirm from '@/apps/office/containers/table/shared/dialogs/steps/Confirm.vue';
import SmartTable from '@/apps/office/containers/smart-table';
import BatchProgress from '@/apps/office/containers/table/shared/dialogs/steps/BatchProgress.vue';
import { House, ActionDialogAttributes, Project, ExportBatch } from '@/types';

type FormData = {
  project: Project;
  batch?: ExportBatch;
  selectedHouses: House[];
};

export default WithSteps<FormData, ActionDialogAttributes<House>>({
  title: 'office.dialogs.houses.clearForInstallation.title',

  formData() {
    const project: Project = this.$store.getters['projects/details'](
      this.$store.state.route.params.id,
    );

    return {
      project,
      selectedHouses: this.$attrs.items.slice(),
    };
  },

  steps: [
    {
      component: SmartTable,

      isValid() {
        return this.$data.selectedHouses.length > 0;
      },

      props() {
        return {
          items: this.$attrs.items,
          columns: ['pchn', 'address', 'city', 'tenantName'],
          settings: 'houses/settings',
          itemKey: 'pchn',
          showSelect: true,
        };
      },

      value: {
        get() {
          return this.$data.selectedHouses;
        },

        set(items: House[]) {
          this.$data.selectedHouses = items;
        },
      },
    },

    {
      component: Confirm,

      value: {
        get() {
          return this.$t('office.dialogs.houses.clearForInstallation.steps[0].title');
        },
      },

      labels: {
        action() {
          return this.$t('office.dialogs.houses.clearForInstallation.action', [
            this.$data.selectedHouses.length,
          ]).toString();
        },
      },

      async afterStep() {
        this.$data.batch = await this.$store.dispatch(
          'projects/regularHouses/bulk:clearForInstallation',
          {
            houses: this.$data.selectedHouses,
            id: this.$data.project.id,
          },
        );
      },
    },

    {
      component: BatchProgress,

      value: {
        get() {
          return this.$data.batch;
        },

        set(val: ExportBatch) {
          this.$data.batch = val;
        },
      },

      props() {
        return {
          batch: this.$data.batch,
        };
      },

      labels: {
        action: 'dialogs.done',
      },

      isValid() {
        return !!this.$data.batch && !!this.$data.batch.finishedAt && !!this.$data.batch.progress;
      },

      afterStep() {
        const proposition = this.$store.state.route.name;
        return this.$store.dispatch(`projects/${proposition}/settings/search`);
      },
    },
  ],
});
